// Vehicle checklist template — based on the standard Diesel & Dust check-in/check-out form
export const CHECKLIST_GROUPS = [
  {
    id: "exterior",
    label: "Exterior",
    items: [
      { id: "aerial", label: "Aerial" },
      { id: "tyres", label: "Tyres" },
      { id: "lights", label: "Lights (head / tail / indicator)" },
      { id: "bumpers", label: "Bumpers" },
      { id: "number_plates", label: "Number plates" },
      { id: "wheel_caps", label: "Wheel caps" },
      { id: "sensors", label: "Sensors (parking / rain / ADAS)" },
      { id: "alarm", label: "Alarm" },
      { id: "central_locking", label: "Central locking" },
      { id: "door_panels", label: "Door panels" },
      { id: "rear_view_mirror", label: "Rear-view mirror" },
      { id: "wipers", label: "Wipers" },
      { id: "windows", label: "Windows (side / rear)" },
    ],
  },
  {
    id: "interior",
    label: "Interior",
    items: [
      { id: "radio", label: "Radio / infotainment" },
      { id: "dashboard", label: "Dashboard" },
      { id: "battery", label: "Battery" },
      { id: "interior_clean", label: "Interior cleanliness" },
      { id: "exterior_clean", label: "Exterior cleanliness" },
    ],
  },
];

export const CHECKLIST_STATES = [
  { value: "ok", label: "OK", color: "#10b981" },
  { value: "damaged", label: "Damaged", color: "#dc2626" },
  { value: "missing", label: "Missing", color: "#f59e0b" },
  { value: "na", label: "N/A", color: "#6b7280" },
];

export const FUEL_LEVELS = ["E", "1/4", "1/2", "3/4", "F"];

export const DELIVERY_METHODS = [
  "Mobile fitment (on-site)",
  "Workshop fitment",
  "Customer drop-off",
];

export const WINDSCREEN_TYPES = [
  "OEM",
  "OEE",
  "Approved aftermarket",
  "Side glass",
  "Rear glass",
  "Other",
];

export const URGENCY_LEVELS = [
  { value: "normal", label: "Normal" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const buildEmptyChecklist = () => {
  const items = [];
  CHECKLIST_GROUPS.forEach((g) =>
    g.items.forEach((it) => items.push({ id: it.id, label: it.label, state: "ok", note: "" }))
  );
  return {
    items,
    fuel_level: "",
    delivery_method: "",
    windscreen_type: "",
    rating_customer_service: 0,
    rating_premises: 0,
    rating_quality_of_work: 0,
    interior_cleanliness: "",
    exterior_cleanliness: "",
    damages: [],
    notes: "",
  };
};
